import { useAuth } from '../../contexts/AuthContext';
import { generateCopy } from '../../clients/copyClient';
import { useState } from 'react';

export default function CopyResult({copy, updateCopy, email, credits, setOpenSubscriptionModal}) {
    const [isLoading, setIsLoading] = useState(false);
    const { authToken } = useAuth();

    const regenerate = async (event) => {
        try {
            setIsLoading(true);
            const copy = await generateCopy(email, authToken, localStorage.getItem('type'));
            updateCopy(copy);
        } catch (error) {
            console.error('Failed to fetch:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="w-full text-start">
                <h2 className="font-semibold text-3xl text-gray-900 mb-6">{copy.subject}</h2>
                <p className="text-left text-lg whitespace-pre-wrap">{copy.body}</p>
                <div className="py-4">
                <button
                        type="button"
                        className="flex items-center rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 hover:opacity-75"
                        onClick={() => {
                            if (credits > 0) {
                                regenerate();
                            } else {
                                setOpenSubscriptionModal(true);
                            }
                        }}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <span className="flex items-center">
                                <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                        fill="none"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                Regenerating...
                            </span>
                        ) : (
                            <>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
  <path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
</svg>


                        &nbsp;&nbsp;Regenerate
                            </>
                        )}
                    </button>
                </div>
            </div>
        </>
    );
}